import { createContext, useContext } from "react";
import { Interpreter } from "xstate";
import { AppContext, AppEvent, AppState } from "./AppMachineUtils";

export type AppServiceType = Interpreter<AppContext, any, AppEvent, AppState>;

export const AppServiceContext = createContext<Interpreter<
  AppContext,
  any,
  AppEvent,
  AppState
> | null>(null);

export function useAppService(): AppServiceType {
  const service = useContext(AppServiceContext);
  if (!service) {
    throw new Error(
      "useAppService must be used within AppServiceContext.Provider",
    );
  }
  return service;
}
